import * as React from 'react'

import { Button, ButtonProps } from '@chakra-ui/react'
import { createLink } from '@tanstack/react-router'
import type { LinkComponent } from '@tanstack/react-router'

export interface LinkButtonProps extends ButtonProps {
  href?: string | object
}

const CreatedLinkButton = createLink(Button)

export const LinkButton: LinkComponent<typeof CreatedLinkButton> = (props) => {
  return <CreatedLinkButton {...props} />
}
